<div class="modal-header d-flex justify-content-center bg-light">
  <h4 class="modal-title text-center strong">{{ 'home.productHeader.SelectProducts' | cxTranslate }}<div class="modalsubheader">{{'tenders.wishto'| cxTranslate}}</div>
  </h4>
</div>
<div class="modal-body bg-light">
  <p class="text-danger text-center strong" *ngIf="checkboxError">Please select one or more materials to proceed</p>
  <div *ngFor="let data of productsInfo.combinedTenders;let i=index">
      <label class="card mt-3 rounded">
          <div class="card-body plr-1  " [ngClass]="{'bg-gray-200': data.checked}" >
              <div class="ml-5  d-flex line-height">
                  <label class="mb-0">
            <input type="checkbox" [(ngModel)]="data.checked" [disabled]="data.isRequired" (change)="onCheckboxChange(data,$event)"/>
<div class="small text-secondary">{{ 'home.headerLinks.material' | cxTranslate }} #{{i+1}}</div>
            <h5 class="strong">{{data.newName?data.newName:data.productName}}</h5>
            <div class="justify-content-between mt-2">
            <div class="row">
              <div class="col left-sect">
              <div class="small text-secondary">{{ 'tenders.Quantity(DMT)' | cxTranslate }} ({{data.displayQuantityUnitDesc}})</div>
              <div class="strong" *ngIf="data.quantity && !data.minimumQuantity && !data.maximumQuantity">{{data.quantity | number}}</div>
              <div class="strong" *ngIf="data.minimumQuantity && data.maximumQuantity">{{data.minimumQuantity | number}} - {{data.maximumQuantity | number}}</div>
            </div>
              <div class="col right-sect">
                <div class="small text-secondary " *ngIf="(productsInfo.commodityType=='CC' || productsInfo.commodityType=='IO') && productsInfo?.arrivalPeriod == 'true'">{{'tenders.ArrivalPeriod'| cxTranslate}}</div>
                <div class="small text-secondary " *ngIf="(productsInfo.commodityType=='CC' || productsInfo.commodityType=='IO') && productsInfo?.arrivalPeriod == 'false'">{{'tenders.LoadPortLaycan'| cxTranslate}}</div> 
                <div class="small text-secondary " *ngIf="(productsInfo.commodityType=='CA') && productsInfo?.arrivalPeriod == 'false'">{{'tenders.schedule'| cxTranslate}}</div> 
                <div class="small text-secondary del" *ngIf="productsInfo.commodityType=='CN'">{{'tenders.Deliveryperiod'| cxTranslate}}</div>
                <div class="small" *ngIf="productsInfo?.arrivalPeriod == 'false'">{{data ?.laycanStartDate | date:"dd/MM/yyyy"}} - {{data ?.laycanEndDate | date:"dd/MM/yyyy"}}</div>
                <div class="small" *ngIf="productsInfo?.arrivalPeriod == 'true'">{{productsInfo ?.arrivalStartDate | date:"dd/MM/yyyy"}} - {{productsInfo ?.arrivalEndDate | date:"dd/MM/yyyy"}}</div>
              </div>
            </div>
            </div>
          </label>
              </div>

          </div>
        </label>
  </div>
</div>

<div class="modal-footer bg-light">
  <div class="w-100">
      <button class="col btn btn-lg btn-primary mb-2" id="material1"   type="submit" (click)="Openmodal()" >{{'tenders.Next'|cxTranslate}}</button>
      <button class="col btn btn-lg btn-light" type="button"  (click)="ActiveModal.dismiss('close click');close()">Cancel</button>
  </div>
</div>